import { ThemeProvider } from "@emotion/react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import ProtectedRoute from "./components/atoms/protected-route/ProtectedRoute";
import { AuthProvider } from "./components/organisms/auth/AuthContext";
import PageNotFound from "./components/pages/Error/PageNotFound";
import theme from "./theme";
import Login from "./components/organisms/login/Login";
import Dashboard from "./components/templates/dashboard/Dashboard";

const App: React.FC = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline /> {/* Normalizes styles across browsers */}
    <GlobalStyles
      styles={{
        body: { fontFamily: "Montserrat, sans-serif" },
        "*": { fontFamily: "Montserrat, sans-serif" },
      }}
    />
    <AuthProvider>
      <Router>
        <div className="App">
          <main>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />}></Route>
                <Route path="/" element={<Dashboard />}></Route>
              </Route>
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthProvider>
  </ThemeProvider>
);

export default App;
